import * as Scrivito from "scrivito"

export enum ContactDetailsWidgetDisplayMode {
  COLUMN = "column",
  ROW = "row"
}

export const ContactDetailsWidget = Scrivito.provideWidgetClass(
  "ContactDetailsWidget",
  {
    attributes: {
      displayMode: [
        "enum",
        { values: Object.values(ContactDetailsWidgetDisplayMode) }
      ],
      contactDetails: ["reference", { only: "ContactDetails" }]
    }
  }
)
